import { type ComponentType, memo, type ReactNode } from 'react';

import { AssetModalMobileTabNavigation } from '~/components/AssetModal/MobileTabNavigation/MobileTabNavigation';
import { MobileVisualizer } from '~/components/AssetModal/Visualizer/MobileVisualizer';

export type AssetModalMobileLayoutProps = {
  Banner?: ComponentType;
  PDFVisualizer: ComponentType;
  PreviousAndNextArrows?: ComponentType;
  VideoVisualizer?: ComponentType;
  panel?: ReactNode;
  header: ReactNode;
  tabs?: ReactNode;
  navigation?: ReactNode;
  /**
   * Rendered as a floating overlay pinned to the bottom-center of the visualizer. Kept media-agnostic
   * so the layout does not depend on any visualizer-specific context (e.g. the PDF paginator lives
   * behind PDFOutlineProvider/Redux and is injected by callers that render PDFs).
   */
  visualizerOverlay?: ReactNode;
};

export const AssetModalMobileLayout = memo(
  ({
    Banner,
    PDFVisualizer,
    PreviousAndNextArrows,
    VideoVisualizer,
    header,
    panel,
    navigation,
    tabs,
    visualizerOverlay,
  }: AssetModalMobileLayoutProps) => {
    return (
      <div
        data-testid="MOBILE_ASSET_MODAL"
        className="fixed inset-y-0 left-0 flex w-screen flex-col items-start justify-start overflow-auto ads:bg-base bg-pigeon-850"
      >
        {!!Banner && <Banner />}
        {header}
        <div className="relative flex h-auto min-h-[200px] w-full shrink-0 bg-black">
          <MobileVisualizer VideoVisualizer={VideoVisualizer} PDFVisualizer={PDFVisualizer} />
          {!!visualizerOverlay && (
            <div className="absolute bottom-3 left-1/2 z-10 -translate-x-1/2">{visualizerOverlay}</div>
          )}
        </div>
        {!!PreviousAndNextArrows && <PreviousAndNextArrows />}
        {navigation ? navigation : <AssetModalMobileTabNavigation tabs={tabs} />}
        {panel}
      </div>
    );
  },
);

AssetModalMobileLayout.displayName = 'AssetModalMobileLayout';
